import { savedOrderDetailsCartLineStyles } from "@insite/content-library/Widgets/SavedOrderDetails/SavedOrderDetailsCartLine";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import { COLORS, TYPOGRAPHY } from "@tSurya/theme/design";
import { css } from "styled-components";

savedOrderDetailsCartLineStyles.savedOrderLineCardAddToListButton = {
    variant: "secondary",
    css: css`
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 5px;
        border: 1px solid ${COLORS.black} !important;
        /* border-radius: 0;
        padding: 10px 34px;
        background: ${getColor("primary")};
        border: 2px solid ${getColor("primary")};
        span[class^="TypographyStyle"] {
            color: ${getColor("common.background")};
            font-size: 14px;
            line-height: ${TYPOGRAPHY.lineHeight.base};
        } */
        /* &:hover {
            background: ${getColor("text.accent")};
            border: 2px solid  background: ${getColor("text.accent")};
            span[class^="TypographyStyle"] {
                color: ${getColor("common.background")};
            }
        } */
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    padding: 0px 10px;
                `,
                null,
                null,
                null,
                null,
            ])}
    `,
};
savedOrderDetailsCartLineStyles.productDescription = {
    productDetailLink: {
        css: css`
            span[class^="TypographyStyle"] {
                color: ${getColor("text.link")};
                &:hover {
                    text-decoration-line: underline;
                }
            }
        `,
    },
};
savedOrderDetailsCartLineStyles.productPartNumbers = {
    erpNumberLabelText: {
        css: css`
            color: ${getColor("text.main")};
        `,
    },
    erpNumberValueText: {
        css: css`
            color: ${getColor("text.main")};
        `,
    },
};
savedOrderDetailsCartLineStyles.productPrice = {
    wrapper: {
        css: css`
            align-items: flex-end;
        `,
    },
    priceLabelText: {
        css: css`
            font-size: 14px;
            text-transform: capitalize;
        `,
    },
    price: {
        priceText: {
            weight: "normal",
            css: css`
                color: ${getColor("text.main")};
            `,
        },
    },
};

savedOrderDetailsCartLineStyles.subtotalWithoutVatText = {
    wrapper: {
        css: css`
            margin-bottom: 6px;
        `,
    },

    heading: {
        css: css`
            text-transform: capitalize;
            font-size: 14px;
        `,
    },
};

savedOrderDetailsCartLineStyles.vatAmount = {};

savedOrderDetailsCartLineStyles.extendedUnitNetPrice = {
    text: {
        weight: 700,
    },

    heading: {
        css: css`
            text-transform: capitalize;
            font-size: 14px;
        `,
        weight: 700,
    },
};

savedOrderDetailsCartLineStyles.productPriceAndQuantityGridItem = {
    width: [12, 12, 7, 7, 7],
    printWidth: 7,
};

savedOrderDetailsCartLineStyles.savedOrderLineCardAddToListGridItem = {
    width: [12, 12, 12, 4, 4],
    printWidth: 0,
    css: css`

        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    justify-content: flex-end;
                `,
                css`
                    justify-content: flex-end;
                `,
                css`
                    justify-content: flex-end;
                `,
                null,
                null,
            ])}
    `,
};

savedOrderDetailsCartLineStyles.priceGridItem = {
    width: [4, 4, 4, 3, 3],
    printWidth: 4,
    css: css`
        flex-direction: column;
    `,
};

savedOrderDetailsCartLineStyles.quantityGridItem = {
    width: [4, 4, 4, 2, 2],
    css: css`
        text-align: center;
    `,
};

savedOrderDetailsCartLineStyles.extendedUnitNetPriceGridItem = {
    width: [4, 4, 4, 3, 3],
    css: css`
        flex-direction: column;
        text-align: right;
    `,
};
savedOrderDetailsCartLineStyles.extendedUnitNetPrice = {
   
  
    text: {
        weight: 700,
    },
    heading: {
        css: css`
            text-transform: capitalize;
             font-weight: 700;
             font-size:14px;
             @media print{
             font-size:12px;
             font-weight: 700;
             }
        `,
    },
};

savedOrderDetailsCartLineStyles.cartLineQuantity = {
    readOnlyQuantityText: {
        extendedStyles: {
            heading: {
                css: css`
                    font-size: 14px;
                    white-space: nowrap;
                    text-transform: capitalize;
                `,
            },
        },
    },
};
